<script>
  import { onMount } from 'svelte';
  import { getApiBase } from './apiBase.js';

  export let params;

  let statusText = 'Opening invoice…';

  function asInt(v) {
    const n = typeof v === 'string' ? Number(v) : v;
    return Number.isFinite(n) ? n : null;
  }

  onMount(async () => {
    const raw = params?.paymentId ?? params?.paymentid ?? null;
    const pid = asInt(raw);

    if (!pid) {
      statusText = 'Missing payment id.';
      return;
    }

    const token = localStorage.getItem('jwtToken');
    if (!token) {
      statusText = 'Not authenticated.';
      return;
    }

    const apiBase = getApiBase();
    const endpoint = `${apiBase}/studentplayground/api/payments/${pid}/invoice-url/`;

    try {
      const res = await fetch(endpoint, { headers: { 'Authorization': `Bearer ${token}` } });
      const text = await res.text();

      if (!res.ok) {
        statusText = `Failed to get invoice link (${res.status}).`;
        return;
      }

      const payload = JSON.parse(text);
      const url = payload?.signed_url;
      if (!url) {
        statusText = 'Missing signed URL in response.';
        return;
      }

      // Redirect this tab to the PDF.
      window.location.replace(url);
    } catch (e) {
      statusText = 'Failed to open invoice.';
    }
  });
</script>

<main class="wrap">
  <div class="card">
    <h1>Invoice</h1>
    <p>{statusText}</p>
  </div>
</main>

<style>
  .wrap {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
  }
  .card {
    width: min(520px, 100%);
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.25rem 1.5rem;
    background: white;
  }
  h1 {
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
  }
  p {
    margin: 0;
    color: #4b5563;
  }
</style>

